import React from 'react';
import { ChevronRight, Star } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export const Solution = () => {
  const {
    t
  } = useLanguage();
  return <section className="py-8 md:py-16 bg-gray-50" data-id="element-273">
      <div className="container mx-auto px-3 md:px-8" data-id="element-274">
        <div className="bg-blue-800 text-white py-2 md:py-3 px-4 md:px-6 rounded-t-lg inline-block mb-4 md:mb-8" data-id="element-275">
          <h2 className="text-base md:text-xl font-bold" data-id="element-276">
            {t('solution.header')}
          </h2>
        </div>
        <h3 className="text-xl md:text-3xl font-bold text-gray-800 mb-4 md:mb-6" data-id="element-277">
          {t('solution.title')}
        </h3>
        <div className="mb-6 md:mb-10" data-id="element-278">
          <p className="text-base md:text-lg text-gray-700 mb-3 md:mb-4" data-id="element-279">
            {t('solution.intro')}
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4 mb-4 md:mb-6" data-id="element-280">
            {[t('solution.benefit1'), t('solution.benefit2'), t('solution.benefit3'), t('solution.benefit4')].map((benefit, index) => <div key={index} className="bg-red-50 p-3 md:p-4 rounded-lg flex items-center" data-id="element-281">
                <Star className="text-red-500 mr-2 flex-shrink-0" size={20} fill="currentColor" data-id="element-282" />
                <span className="text-sm md:text-base font-semibold" data-id="element-283">
                  {benefit}
                </span>
              </div>)}
          </div>
          <p className="text-base md:text-lg text-gray-700 italic" data-id="element-284">
            {t('solution.outro')}
          </p>
        </div>
        <h4 className="text-xl md:text-2xl font-bold text-gray-800 mb-4 md:mb-6" data-id="element-285">
          {t('solution.howTitle')}
        </h4>
        <div className="space-y-4 md:space-y-8 mb-6 md:mb-10" data-id="element-286">
          {[{
          title: t('solution.feature1Title'),
          description: t('solution.feature1Desc')
        }, {
          title: t('solution.feature2Title'),
          description: t('solution.feature2Desc')
        }, {
          title: t('solution.feature3Title'),
          description: t('solution.feature3Desc')
        }, {
          title: t('solution.feature4Title'),
          description: t('solution.feature4Desc')
        }, {
          title: t('solution.feature5Title'),
          description: t('solution.feature5Desc')
        }].map((feature, index) => <div key={index} className="flex" data-id="element-287">
              <div className="mr-3 md:mr-4 mt-1" data-id="element-288">
                <Star className="text-yellow-500" size={20} data-id="element-289" />
              </div>
              <div data-id="element-290">
                <h5 className="text-lg md:text-xl font-semibold text-gray-800 mb-1 md:mb-2" data-id="element-291">
                  {feature.title}
                </h5>
                <p className="text-sm md:text-base text-gray-700" data-id="element-292">
                  {feature.description}
                </p>
              </div>
            </div>)}
        </div>
        <div className="text-center" data-id="element-293">
          <a href="https://knovastore.com/cart/47931982774491:1" className="flex items-center justify-center mx-auto bg-green-500 hover:bg-green-600 text-white font-bold py-3 md:py-4 px-6 md:px-8 rounded-lg text-base md:text-lg transition duration-300" data-id="element-294">
            {t('solution.cta')}
            <ChevronRight className="ml-2" size={20} data-id="element-295" />
          </a>
        </div>
      </div>
    </section>;
};